export default {
  email: "郵箱&nbsp;&nbsp;softdev@zero2ipo.com.cn",
  location: "香港九龍柯士甸道西1號 環球貿易廣場15樓1506B室",
};
